import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-width": ".5",
      d: "M17.33 1.014c-2.45 0-4.472 2.275-5.29 3.349-.818-1.074-2.84-3.349-5.29-3.349C3.58 1.014 1 3.93 1 7.512c0 1.954.776 3.776 2.134 5.023q.03.051.072.093l8.51 8.492a.46.46 0 0 0 .65 0l8.791-8.79.091-.087c.072-.068.143-.137.222-.225a.5.5 0 0 0 .082-.11c.986-1.207 1.528-2.765 1.528-4.396 0-3.583-2.58-6.498-5.75-6.498Zm3.457 10.377a.4.4 0 0 0-.035.047q-.066.072-.137.137l-8.575 8.57-8.079-8.063a.5.5 0 0 0-.107-.137c-1.23-1.073-1.934-2.69-1.934-4.433 0-3.075 2.167-5.578 4.83-5.578 2.633 0 4.88 3.435 4.903 3.47.17.262.604.262.774 0 .022-.035 2.27-3.47 4.903-3.47 2.663 0 4.83 2.503 4.83 5.578 0 1.449-.488 2.827-1.373 3.879Z"
    }, null, -1)
  ])))
}
export default { render: render }